import { API } from '@/config/api'
import request from '@/utils/request'

const TOKEN_KEY = 'bankflow_token'

const state = {
  token: localStorage.getItem(TOKEN_KEY) || '',
  userinfo: null
}

const getters = {
  token: state => state.token,
  userinfo: state => state.userinfo,
  isLoggedIn: state => !!state.token
}

const mutations = {
  SET_TOKEN(state, token) {
    state.token = token
    if (token) {
      localStorage.setItem(TOKEN_KEY, token)
    } else {
      localStorage.removeItem(TOKEN_KEY)
    }
  },
  SET_USERINFO(state, userinfo) {
    state.userinfo = userinfo
  }
}

const actions = {
  // 账号密码登录
  async login({ commit }, { account, password }) {
    const res = await request({
      url: API.AUTH_LOGIN,
      method: 'post',
      data: { account, password }
    })
    const { token, userinfo } = res.data
    commit('SET_TOKEN', token)
    commit('SET_USERINFO', userinfo)
    return res
  },
  // 退出登录
  async logout({ commit }) {
    try {
      await request({
        url: API.AUTH_LOGOUT,
        method: 'post'
      })
    } finally {
      commit('SET_TOKEN', '')
      commit('SET_USERINFO', null)
    }
  },
  // 获取当前用户信息
  async fetchUserinfo({ commit }) {
    const res = await request({
      url: API.AUTH_USERINFO,
      method: 'get'
    })
    commit('SET_USERINFO', res.data)
    return res
  },
  // 修改密码：成功后原 token 失效，需重新登录
  async changepwd({ commit }, { oldpassword, newpassword }) {
    await request({
      url: API.AUTH_CHANGEPWD,
      method: 'post',
      data: { oldpassword, newpassword }
    })
    // FastAdmin 改密后会删除当前 token，清状态由调用方跳登录
    commit('SET_TOKEN', '')
    commit('SET_USERINFO', null)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
